import { Injectable } from '@angular/core';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { debounceTime, map, shareReplay, throttleTime } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RequestLoaderService {
  public throttleTimeOffset: number = 10;
  public debounceTimeOffset: number = 6000;
  public isLoadingAPI$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public isLoadingUI$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() {}

  public showAPILoader(): void {
    this.isLoadingAPI$.next(true);
  }

  public hideAPILoader(): void {
    this.isLoadingAPI$.next(false);
  }

  public get isLoadingAPIVal$(): Observable<boolean> {
    // avoid flickering of multiple loading indicators

    return merge(
      this.isLoadingAPI$,
      this.isLoadingAPI$.pipe(
        debounceTime(this.debounceTimeOffset),
        map(() => false),
      ),
    ).pipe(throttleTime(this.throttleTimeOffset), shareReplay());
  }

  public showUILoader(): void {
    this.isLoadingUI$.next(true);
  }

  public hideUILoader(): void {
    this.isLoadingUI$.next(false);
  }

  public get isLoadingUIVal$(): Observable<boolean> {
    return this.isLoadingUI$.pipe(shareReplay());
  }
}
